import { ChangeDetectionStrategy, Component, ChangeDetectorRef,OnInit, ViewEncapsulation, ElementRef, AfterViewInit, ViewChild, Input } from '@angular/core';
import { recepientTableColumns, recepientTableInit } from '../../constants';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FilterOverlayDialogComponent } from '../filter-overlay-dialog/filter-overlay-dialog.component';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'dl-contacts-table',
  templateUrl: './contacts-table.component.html',
  styleUrls: ['./contacts-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ContactsTableComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  
  public contactDataObj: any = [];
  public notificationDataObj: any;
  public notificationStatusIcon: {};
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public dataSource = new MatTableDataSource<any>();
  public displayedColumns = ['select', 'allColumns'];
  public tableData: any[] = [];
  public selectedColumns: any;
  public StatusData: any;
  public notificationId: string;
  public notificationData: any;
  public filterOverlayData: any;
  public notificationLabel: any = '';
  public isSetCom: boolean = false;
  public accDataObj: any;

  constructor(
    private _cdr: ChangeDetectorRef,
    public filterOverlay: FilterOverlayDialogService,
    private readonly dialog: MatDialog,
  ) {
    this.notificationDataObj = history.state.notificationDataObj;
    this.accDataObj = history.state.customerDetails.customerData;
    if (this.notificationDataObj) {
      this.notificationData = this.notificationDataObj.notificationData;
      this.notificationId = this.notificationData.NotificationId;
      this.contactDataObj = this.notificationDataObj.contactData;
    } 
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    this.tableData = recepientTableColumns;
    this.dataSource.data = this.tableData;
    const sessionColumnsData = JSON.parse(sessionStorage.getItem('SelectedColumns'));
    this.selectedColumns = sessionColumnsData && sessionColumnsData.length > 0 ? sessionColumnsData : recepientTableInit;
  }
  
  public isAllSelected($event) {
    const numSelected = this.selection.selected.length;
    const numDisabled = this.dataSource.data.filter(row => row.disabled).length;
    const numRows = this.dataSource.data.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggle($event) {
    this.isAllSelected($event) ? this.selection.clear() : this.dataSource.data.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }

  public handleChecked(row: any) {
    if (!row.disabled) {
      this.selection.toggle(row);
    }
  }

  public getSelectedColumns() {
    this.selectedColumns = this.selection.selected.length > 0 ? this.selection.selected : recepientTableInit;
    sessionStorage.setItem('SelectedColumns', JSON.stringify(this.selectedColumns));
    this._cdr.detectChanges();
  }

  public ngAfterViewInit(): void {
    this.dataSource.data.forEach(row => {
      const hasSelect = this.selectedColumns.some((item: any) => item.key === row.key);
      !row.disabled && hasSelect ? this.selection.select(row) : '';
    });
  }

  public filterData() {
    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterOverlayData = filterValue;
    });
    this.dialog.open(FilterOverlayDialogComponent, {
      data: this.filterOverlayData,
      autoFocus:false
    });
  }

}
